import type { ConstructorPlan } from './constructorTypes'

const TTL_MS = 5 * 60 * 1000

type CacheEntry = {
  savedAt: number
  plans: ConstructorPlan[]
}

function cacheKey(tenantId: string): string {
  return `staff_constructor_plans_v1:${tenantId}`
}

export function readConstructorPlansCache(tenantId: string): ConstructorPlan[] | null {
  try {
    const raw = sessionStorage.getItem(cacheKey(tenantId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as CacheEntry
    if (!Array.isArray(parsed.plans) || Date.now() - parsed.savedAt > TTL_MS) return null
    return parsed.plans
  } catch {
    return null
  }
}

export function writeConstructorPlansCache(tenantId: string, plans: ConstructorPlan[]): void {
  try {
    const payload: CacheEntry = { savedAt: Date.now(), plans }
    sessionStorage.setItem(cacheKey(tenantId), JSON.stringify(payload))
  } catch {
    // ignore quota / private mode
  }
}

export function parseInitialPlanIdFromUrl(): number | null {
  const params = new URLSearchParams(window.location.search)
  const rawPlanId = params.get('plan_id') ?? params.get('plan')
  if (!rawPlanId) return null
  const planId = Number(rawPlanId)
  return Number.isFinite(planId) && planId > 0 ? planId : null
}
